import React from "react";
import "../privacypolicy/Privacypolicy.css";
import { Link } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";

const PrivacyPolicy = () => {
  return (
    <div>   
      <Header />
      <div className="terms-page">
        <h4>Privacy Policy – AstroBhagya</h4>
        <p>
          <b>AstroBhagya App</b>, developed and managed by{" "}
          <b>Heavenly Expectation Private Limited</b>, offers trusted astrology
          services and personalized guidance in a modern digital format.
        </p>
        <p>
          AstroBhagya ("AstroBhagya", "we", "our", "us", "the Platform")
          operates an online platform and mobile application that enables users
          to obtain astrology-related consultations, including but not limited
          to live chat sessions, telephone calls, and other interactive services
          ("Services"). This Privacy Policy describes in detail how we collect,
          store, use, process, retain and disclose your information when you
          access or use our Platform as an astrologer, customer, or visitor.
        </p>
        <p>
          This Privacy Policy is published in accordance with the Information
          Technology Act, 2000, the Information Technology (Intermediary
          Guidelines) Rules, 2011 and the Information Technology (Reasonable
          Security Practices and Procedures and Sensitive Personal Data or
          Information) Rules, 2011. It applies to all users of the Platform,
          regardless of whether they register an account or simply browse the
          site or app.
        </p>
        <p>
          By accessing or using our Platform, you acknowledge that you have read
          and understood this Privacy Policy and agree to be bound by its terms.
          If you do not agree with any part of this Privacy Policy, you should
          discontinue using the Platform immediately.
        </p>
        <p>
          AstroBhagya maintains a transparent pricing structure for all
          consultations conducted on the platform. New users may be eligible for
          a 20% discount on their first recharge, subject to the terms of the
          promotional offer in effect at the time of recharge. The discount is
          applicable only on eligible recharge amounts made using a valid
          promotional mechanism provided within the platform.
        </p>
        <p>
          After completion of the recharge, consultation charges for chat and
          call services shall be deducted on a per-minute basis as per the
          astrologer's applicable rate, with a minimum base rate of ₹10 (Indian
          Rupees) per minute. The exact per-minute charge will be displayed to
          the user before initiating any paid consultation.
        </p>
        <p>
          All service prices are displayed in Indian Rupees (₹). Applicable
          taxes, if any, shall be reflected separately on the platform. Users
          and Astrologers are responsible for complying with tax obligations
          under applicable laws.
        </p>

        {/* ───────────────────────── 1 ───────────────────────── */}
        <h5>1. User Consent</h5>
        <p>
          When you engage with <strong>AstroBhagya</strong>, whether by
          registering an account, logging in, purchasing or booking a
          consultation, sending a query, or interacting with any feature of our
          platform, you are explicitly providing your free, informed, and
          unconditional consent to the collection, processing, storage, use, and
          disclosure of your personal and non-personal information as outlined
          in this Privacy Policy. By continuing to use our services, you
          acknowledge and agree to the terms described herein.
        </p>
        <p>
          Your consent is not limited to a single activity but broadly covers
          multiple facets of how we handle your information. Specifically, it
          includes, but is not limited to, the following areas:
        </p>
        <ul>
          <li>
            <strong>Collection of Data:</strong> Your consent authorizes
            AstroBhagya to collect both personal and non-personal data from you.
            Personal data includes any information that can identify you, either
            directly or indirectly. Non-personal data includes technical and
            usage information that cannot identify you individually but helps us
            improve our services.
          </li>
          <li>
            <strong>Use of Cookies and Tracking Technologies:</strong> To
            enhance user experience and provide personalized content, we utilize
            cookies, analytics tools, and other tracking technologies. These
            tools help us understand your interactions with our platform,
            optimize the services you receive, and allow us to make informed
            improvements.
          </li>
          <li>
            <strong>Processing and Retention of Data:</strong> The information
            collected is processed and retained for as long as necessary to
            achieve the purposes outlined in this Privacy Policy. This includes
            delivering services, providing support, fulfilling legal obligations,
            preventing fraud, and improving our platform.
          </li>
          <li>
            <strong>Transfer of Data:</strong> Your data may be transferred to
            our trusted service providers and partners, including those located
            outside India. Such transfers are conducted only for lawful purposes
            and under appropriate safeguards to ensure the security and
            confidentiality of your information.
          </li>
          <li>
            <strong>Withdrawal of Consent:</strong> You have the right to
            withdraw your consent at any time. This can be done either by
            deleting your account through the platform or by contacting our
            designated Grievance Officer. It is important to note that
            withdrawal of consent may limit your ability to access certain
            features or services, as some functionalities require the processing
            of your data to function correctly.
          </li>
        </ul>
        <p>
          By providing your consent, you enable <strong>AstroBhagya</strong> to
          operate efficiently while safeguarding your privacy rights, ensuring
          transparency, and maintaining compliance with applicable laws.
        </p>

        {/* ───────────────────────── 2 ───────────────────────── */}
        <h5>2. Information We Collect</h5>
        <p>
          To provide, maintain, and continuously improve our services, we
          collect various categories of information from our users. This
          information helps us personalize your experience, provide accurate
          astrological guidance, process payments, and maintain the security of
          the platform. The data collected can be classified into three main
          categories: personal information, non-personal information, and
          voice/audio data.
        </p>

        <strong>(a) Personal Information</strong>
        <p>
          Personal information is any data that identifies you as an individual.
          Depending on the services you use, we may collect the following:
        </p>
        <ul>
          <li>
            <strong>Identity Details:</strong> These include your full name,
            mobile number, email address, and any government-issued
            identification required for verification purposes. Collecting this
            information ensures that your account is authentic and secure,
            helping us prevent fraud and unauthorized access.
          </li>
          <li>
            <strong>User Data Collection:</strong> We may collect the following
            user information: Name, mobile number, and email address, chat and
            call history (for service quality, compliance, and internal
            analysis), and payment-related information processed via secure
            third-party payment gateways.
          </li>
          <li>
            <strong>Astrologer Data Collection:</strong> Aadhaar card, PAN card,
            and bank details are collected solely for identity verification and
            payout purposes. Documents are not shared with third parties, except
            where required by law or regulatory authorities.
          </li>
          <li>
            <strong>Astrology-Related Details:</strong> To provide personalized
            astrological guidance, we may request information such as your date
            of birth, time of birth, place of birth, gender, and other relevant
            details. While these details are optional, they are critical for
            astrologers to deliver accurate readings and tailored guidance.
            Sharing accurate birth information ensures precise horoscope
            calculations, astrological predictions, and personalized advice.
          </li>
          <li>
            <strong>Profile Data:</strong> Users can optionally create a profile
            with a display picture, description, and other personal information.
            Profile data helps personalize your experience on the platform,
            allowing astrologers to better understand your preferences and
            providing a richer, more interactive experience.
          </li>
          <li>
            <strong>Payment and Billing Information:</strong> To facilitate
            transactions, we collect certain billing and payment details. This
            may include transaction history, billing address, and partial
            payment instrument information, such as the last four digits of your
            card. Importantly, full card or bank details are never stored on our
            servers; all sensitive transactions are handled through secure,
            third-party payment gateways.
          </li>
          <li>
            <strong>Sensitive Personal Data:</strong> In some cases, you may
            voluntarily share sensitive information during consultations. This
            includes health-related details or other sensitive personal data as
            defined under applicable law. Such information is treated with the
            highest degree of confidentiality, stored securely, and only used to
            provide the services requested.
          </li>
        </ul>
        <p>
          <strong>How Personal Information is Collected:</strong>
        </p>
        <ul>
          <li>During account registration or profile creation.</li>
          <li>When booking or paying for consultations via chat or call.</li>
          <li>While submitting feedback, reviews, or queries.</li>
          <li>When participating in promotions, surveys, or contests.</li>
        </ul>
        <p>
          Users are encouraged to provide accurate and up-to-date information.
          The authenticity and correctness of the information provided remain
          the responsibility of the user.
        </p>

        <strong>(b) Non-Personal Information</strong>
        <p>
          Non-personal information refers to data that does not directly
          identify you but is essential for the efficient operation of our
          platform and improvement of services. We collect this information
          automatically, including:
        </p>
        <ul>
          <li>
            <strong>Technical Data:</strong> Information about your device and
            network, such as browser type and version, operating system, device
            model, unique device identifiers, IP address, telecom provider, and
            language settings. This data helps us ensure compatibility and
            optimal performance of the platform across different devices and
            networks.
          </li>
          <li>
            <strong>Usage Data:</strong> We record data on how you interact with
            our platform, including date and time of visits, pages viewed, time
            spent on each page, search queries, clickstream data, referring
            URLs, and other interaction metrics. This information helps us
            understand user behavior, optimize content, and enhance user
            experience.
          </li>
          <li>
            <strong>Geographical Data:</strong> Approximate location information
            inferred from your IP address or device settings helps us provide
            location-based services, such as local astrological recommendations
            or tailored promotions.
          </li>
          <li>
            <strong>Aggregated Data:</strong> We compile statistical or
            demographic information from multiple users to analyze trends, assess
            the performance of our platform, and improve services. Aggregated
            data does not reveal individual identities and is used solely for
            analytical purposes.
          </li>
        </ul>
        <p>
          Non-personal information allows us to maintain, improve, and optimize
          our services while protecting your privacy.
        </p>

        <strong>(c) Voice and Microphone Permissions</strong>
        <p>
          To enhance the user experience and make our services more interactive,
          AstroBhagya provides features that enable you to communicate with
          astrologers using your voice. This includes sending voice notes,
          participating in voice consultations, and using audio commands instead
          of typing.
        </p>
        <ul>
          <li>
            <strong>Microphone Access:</strong> The app requests permission to
            access your device's microphone. Granting this permission allows the
            app to capture your voice and convert it into digital audio data for
            processing.
          </li>
          <li>
            <strong>Active Recording:</strong> Audio is recorded or transmitted
            only when you actively engage with the voice features, such as
            pressing the record button or joining a voice call. The app does not
            listen or record in the background.
          </li>
          <li>
            <strong>Storage and Security:</strong> Voice recordings are
            transmitted and stored securely and are used solely for providing
            the requested service. After completion of the service, recordings
            are either deleted or anonymized unless retention is required by
            law.
          </li>
          <li>
            <strong>Optional Use:</strong> If you prefer not to use audio
            features, you may deny microphone access in your device settings.
            Text-based services remain fully functional and unaffected by this
            choice.
          </li>
        </ul>
        <p>
          By providing access to your microphone, you help us create a more
          natural and personalized consultation experience while retaining
          control over your privacy.
        </p>

        {/* ───────────────────────── 3 ───────────────────────── */}
        <h5>3. How We Use Your Information</h5>
        <p>
          The information collected is used for a variety of lawful business
          purposes. These purposes ensure smooth operation, personalized
          services, security, legal compliance, and continuous improvement of
          the platform.
        </p>
        <ul>
          <li>
            <strong>Service Delivery:</strong> Personal information allows us to
            register your account, verify your identity, facilitate chat and
            call consultations, process transactions, and deliver digital content
            or products purchased. Without accurate personal data, the delivery
            of these services would not be possible.
          </li>
          <li>
            <strong>Personalization:</strong> We use your astrology-related
            details and usage patterns to provide personalized recommendations,
            content, and offers. Personalization improves the relevance of the
            information presented, ensuring that you receive astrological
            guidance and services tailored to your unique profile.
          </li>
          <li>
            <strong>Communication:</strong> Your information enables us to send
            transactional messages, confirmations, reminders, and administrative
            updates. When permitted, we may also send promotional emails or SMS
            regarding new services, offers, or features that may interest you.
          </li>
          <li>
            <strong>Security and Fraud Prevention:</strong> We utilize collected
            data to detect and prevent unauthorized access, fraudulent
            transactions, spam, and other unlawful activities. Security measures
            include monitoring for suspicious activity, authentication
            procedures, and encryption to protect sensitive information.
          </li>
          <li>
            <strong>Analytics and Improvement:</strong> Aggregated and
            non-personal data is analyzed to identify trends, measure platform
            performance, diagnose technical issues, and inform the development of
            new features. This ongoing analysis ensures that our services evolve
            in line with user needs and technological advancements.
          </li>
          <li>
            <strong>Legal Compliance:</strong> AstroBhagya may use your data to
            comply with applicable laws, regulations, legal processes, or
            enforceable governmental requests. Legal compliance ensures both the
            platform's integrity and the protection of your rights under law.
          </li>
          <li>
            <strong>Commitment to Privacy:</strong> AstroBhagya does not sell,
            rent, or trade your personal information to third parties for
            marketing purposes. All data usage is confined to the purposes
            stated above and is managed in accordance with industry-standard
            security practices.
          </li>
        </ul>

        {/* ───────────────────────── 4 ───────────────────────── */}
        <h5>4. Cookies and Tracking Technologies</h5>
        <p>
          AstroBhagya uses cookies, pixels, beacons, and similar tracking
          technologies to enhance your experience, improve platform
          functionality, and deliver personalized content and services. These
          tools are widely used across the internet and help platforms remember
          user preferences, understand interactions, and measure performance.
        </p>

        <p>
          <strong>Purpose of Cookies and Tracking Technologies</strong>
        </p>
        <ul>
          <li>
            <strong>Device Recognition:</strong> Cookies allow the Platform to
            recognise your device when you return. This helps us provide a
            seamless experience, such as keeping you logged in or remembering
            the last actions you performed, so you don't need to repeat them
            each time you visit.
          </li>
          <li>
            <strong>Preference and Login Management:</strong> Cookies store your
            preferences, such as language settings, display choices, and login
            credentials. By remembering these preferences, the Platform delivers
            a more personalized experience without requiring repeated
            configuration.
          </li>
          <li>
            <strong>Usage Analysis:</strong> Tracking technologies provide
            insight into how users interact with the Platform. For example, we
            can see which features are most popular, how users navigate pages,
            and where improvements are needed. This data helps us optimize the
            Platform, fix bugs, and enhance overall usability.
          </li>
          <li>
            <strong>Advertising and Marketing Measurement:</strong> Cookies,
            pixels, and beacons allow us to measure the effectiveness of
            advertisements, promotions, or campaigns shown to you, either on our
            Platform or through third-party channels. We can understand which
            ads generate engagement or conversions, enabling more relevant offers
            and marketing content.
          </li>
        </ul>

        <p>
          <strong>User Control Over Cookies</strong>
        </p>
        <ul>
          <li>
            Users have control over cookies through their browser or device
            settings. You can choose to accept, reject, or delete cookies at any
            time. However, it is important to note that disabling cookies may
            affect certain features or functionalities of the Platform, such as
            automatic login, personalized recommendations, or seamless
            navigation.
          </li>
          <li>
            By using our Platform, you consent to the use of cookies and
            tracking technologies as described, unless you explicitly disable
            them through your settings.
          </li>
        </ul>

        {/* ───────────────────────── 5 ───────────────────────── */}
        <h5>5. Third-Party Services</h5>
        <p>
          AstroBhagya may interact with, or link to, third-party services,
          applications, and payment gateways. While we strive to work with
          trusted partners, it is important to understand that your interactions
          with third parties are governed by their respective privacy policies.
          AstroBhagya is not responsible for how these third parties collect,
          use, or share your data.
        </p>

        <p>
          <strong>Types of Third-Party Services</strong>
        </p>
        <ul>
          <li>
            <strong>External Links:</strong> Our Platform may contain links to
            third-party websites or apps that are not controlled by AstroBhagya.
            When you click on such links, you may be directed to platforms with
            their own terms and privacy policies. We encourage you to review
            those policies carefully before sharing personal information.
          </li>
          <li>
            <strong>Service Providers and Vendors:</strong> We engage trusted
            third-party providers to perform specific functions on our behalf.
            These may include, but are not limited to:
            <ul>
              <li>
                <strong>Hosting and Infrastructure Services:</strong> Providers
                who maintain and manage the servers and cloud infrastructure
                hosting our platform.
              </li>
              <li>
                <strong>Analytics Providers:</strong> Services that help analyze
                user behavior, app performance, and engagement metrics.
              </li>
              <li>
                <strong>Marketing Support:</strong> Tools that assist in
                delivering promotions, advertisements, or personalized
                communication.
              </li>
              <li>
                <strong>Payment Processors:</strong> Secure third-party gateways
                that facilitate transactions and ensure the safe handling of
                financial information.
              </li>
            </ul>
            These providers are contractually obligated to process your
            information solely for the purposes specified by AstroBhagya. They
            must implement appropriate technical and organizational measures to
            protect your data from unauthorized access, use, or disclosure.
          </li>
        </ul>

        <p>
          <strong>Limitation of Liability</strong>
        </p>
        <ul>
          <li>
            While we carefully select third-party partners, AstroBhagya cannot
            be held responsible for their practices, services, or content. Any
            personal information shared with a third-party service is subject to
            that service's privacy policy, and you should exercise caution and
            discretion when providing data.
          </li>
        </ul>

        {/* ───────────────────────── 6 ───────────────────────── */}
        <h5>6. Data Retention and Deletion</h5>
        <p>
          AstroBhagya is committed to ensuring that your data is retained only
          as long as necessary to fulfil the purposes outlined in this Privacy
          Policy, comply with legal obligations, resolve disputes, and enforce
          agreements.
        </p>

        <p>
          <strong>Data Retention Guidelines</strong>
        </p>
        <ul>
          <li>
            <strong>Purpose-Based Retention:</strong> We retain your personal
            data for as long as it is required to deliver the services you
            requested. For example:
            <ul>
              <li>
                User account information remains active until you choose to
                delete your account.
              </li>
              <li>
                Astrology consultation data may be stored to maintain a history
                of your readings and preferences.
              </li>
              <li>
                Payment and billing information is retained to comply with
                accounting and tax requirements.
              </li>
            </ul>
          </li>
          <li>
            <strong>Legal and Compliance Obligations:</strong> In some cases,
            retention is required by law. This may include transaction records
            for taxation, financial audits, or other regulatory obligations.
            Even after account deletion, certain information may be retained in
            secure archives to meet these legal requirements.
          </li>
        </ul>

        <p>
          <strong>Account Deletion Process</strong>
        </p>
        <ul>
          <li>
            Users may request account deletion at any time using the "Delete
            Account" option in the app or by contacting AstroBhagya directly.
            Upon receiving a deletion request:
            <ul>
              <li>
                Your profile, personal data, and associated records will be
                removed from active systems within a reasonable timeframe.
              </li>
              <li>
                Non-personal or anonymized data may be retained for analytical
                purposes, system maintenance, or security reasons.
              </li>
              <li>
                Any data required for legal compliance, dispute resolution, or
                enforcement of agreements will be securely stored until the
                legal obligation is satisfied.
              </li>
            </ul>
          </li>
        </ul>

        <p>
          <strong>Account Deletion &amp; Misuse</strong>
        </p>
        <ul>
          <li>
            Deleting an account does not restore eligibility for the 20% off on
            chat &amp; call offer.
          </li>
          <li>
            If misuse, fraud, or policy violations are detected, the Company
            reserves the right to permanently block or terminate accounts
            without notice.
          </li>
        </ul>

        <p>
          <strong>Your Rights Regarding Data Deletion</strong>
        </p>
        <ul>
          <li>
            Deleting your account effectively withdraws your consent for further
            processing of personal data, except for legally mandated retention.
            Users retain the right to request additional information about data
            retention periods or specific data held by AstroBhagya.
          </li>
        </ul>
        <p>
          By implementing clear retention and deletion practices, AstroBhagya
          ensures that your personal information is treated responsibly,
          minimizing unnecessary storage and protecting your privacy.
        </p>

        {/* ───────────────────────── 7 ───────────────────────── */}
        <h5>7. Children's Privacy</h5>
        <p>
          AstroBhagya is intended for use by individuals aged 18 years and
          older. We take the protection of children's privacy seriously and do
          not knowingly collect personal information from children under the age
          of 13.
        </p>

        <p>
          <strong>Parental Rights and Responsibilities</strong>
        </p>
        <ul>
          <li>
            <strong>Parental Control:</strong> If a parent or guardian believes
            that their child has inadvertently provided personal information on
            the Platform, they should contact AstroBhagya immediately at the
            designated email address provided below.
          </li>
          <li>
            <strong>Prompt Action:</strong> Upon receiving such a request,
            AstroBhagya will take immediate steps to delete the child's personal
            information from our systems, ensuring that no data is retained in
            active records or used for any services.
          </li>
          <li>
            <strong>Limited Services for Minors:</strong> While the Platform may
            be accessed by teenagers or young adults above the minimum age
            requirement for legal agreements (18+), minors should use the
            Platform only under parental guidance. Personal data collected from
            individuals under the appropriate age may not be used to provide
            personalized astrological guidance until they meet the required age
            threshold.
          </li>
        </ul>
        <p>
          By establishing strict age requirements and deletion protocols,
          AstroBhagya ensures compliance with children's privacy laws and
          promotes a safe online environment.
        </p>

        {/* ───────────────────────── 8 ───────────────────────── */}
        <h5>8. Security Measures</h5>
        <p>
          At AstroBhagya, the security of your information is a top priority. We
          implement a range of physical, technical, and organizational measures
          to protect your data from unauthorized access, disclosure, alteration,
          or destruction. All personal data is stored using reasonable security
          practices and encryption measures. The Company uses secure servers and
          safeguards to protect user information from unauthorized access.
        </p>

        <p>
          <strong>Key Security Measures</strong>
        </p>
        <ul>
          <li>
            <strong>Secure Servers and Firewalls:</strong> All data is stored on
            secure servers that are protected with firewalls and other access
            controls to prevent unauthorized intrusion.
          </li>
          <li>
            <strong>Data Transmission Encryption:</strong> Information
            transmitted between your device and our servers is encrypted using
            SSL/TLS protocols, ensuring that your data cannot be intercepted or
            read during transmission.
          </li>
          <li>
            <strong>Access Controls:</strong> Access to personal data within
            AstroBhagya is restricted on a need-to-know basis. Only authorized
            personnel who require access to perform their job functions can view
            or handle personal information.
          </li>
          <li>
            <strong>Regular Monitoring and Updates:</strong> We conduct periodic
            security audits, vulnerability assessments, and software updates to
            identify potential threats and maintain the integrity of our systems.
          </li>
        </ul>

        <p>
          <strong>Limitations of Security</strong>
        </p>
        <ul>
          <li>
            Despite implementing robust security measures, no method of data
            transmission over the internet or electronic storage can be
            guaranteed to be completely secure. Users are strongly advised to:
            <ul>
              <li>Keep their login credentials confidential.</li>
              <li>
                Avoid sharing sensitive information through unsecured channels.
              </li>
              <li>Use strong, unique passwords and update them regularly.</li>
            </ul>
          </li>
        </ul>
        <p>
          By following these practices, users contribute to the overall security
          of their accounts and personal information.
        </p>

        {/* ───────────────────────── 9 ───────────────────────── */}
        <h5>9. Disclosure in Special Circumstances</h5>
        <p>
          AstroBhagya may disclose your information in specific situations where
          such disclosure is necessary or legally required. These disclosures
          are strictly limited to the extent needed and are governed by
          applicable laws.
        </p>

        <p>
          <strong>Circumstances for Disclosure</strong>
        </p>
        <ul>
          <li>
            <strong>Legal Obligations:</strong> We may disclose your personal
            information to comply with laws, regulations, legal processes, or
            government requests, including subpoenas or court orders.
          </li>
          <li>
            <strong>Protection of Rights and Safety:</strong> Your information
            may be disclosed to protect and defend the rights, property, or
            safety of AstroBhagya, our users, or the public. This includes cases
            of suspected fraud, unauthorized use, or threats to safety.
          </li>
          <li>
            <strong>Investigation of Wrongdoing:</strong> If there is suspicion
            of illegal activity, abuse of the Platform, or violation of our
            Terms &amp; Conditions, personal information may be shared with law
            enforcement or regulatory authorities for investigation purposes.
          </li>
          <li>
            <strong>Enforcement of Agreements:</strong> Information may be used
            to enforce our Terms &amp; Conditions, privacy policy, or other
            agreements with users, ensuring compliance and accountability.
          </li>
        </ul>
        <p>
          Wherever feasible and legally permissible, AstroBhagya will notify
          users prior to disclosure of personal information in these
          circumstances. However, there may be situations where notification is
          legally prohibited or impractical.
        </p>

        {/* ───────────────────────── 10 ───────────────────────── */}
        <h5>10. User Responsibilities</h5>
        <p>
          Users of AstroBhagya are responsible for ensuring that the information
          they provide is accurate, authentic, complete, and up-to-date. This is
          essential for delivering high-quality astrological guidance and
          maintaining the integrity of the Platform.
        </p>

        <p>
          <strong>Key Responsibilities</strong>
        </p>
        <ul>
          <li>
            <strong>Accuracy of Information:</strong> All data provided during
            account registration, profile updates, consultations, or
            interactions with the Platform must be accurate and true to the best
            of the user's knowledge.
          </li>
          <li>
            <strong>Indemnification:</strong> Users agree to indemnify and hold
            AstroBhagya harmless from any loss, liability, or damage arising
            from the provision of inaccurate, false, or unauthorized information.
          </li>
          <li>
            <strong>Consequences of Misrepresentation:</strong> Submitting false
            information may result in:
            <ul>
              <li>Limited access or suspension of the account.</li>
              <li>
                Inaccurate service delivery (e.g., incorrect astrological
                readings).
              </li>
              <li>
                Liability for damages caused to AstroBhagya or other users.
              </li>
            </ul>
          </li>
          <li>
            <strong>Responsible Use of Platform:</strong> Users must not misuse
            the Platform, including attempts to manipulate data, breach security,
            or use the Platform for unlawful purposes. Adherence to user
            responsibilities ensures a safe, reliable, and trustworthy
            environment for all participants.
          </li>
        </ul>
        <p>
          By maintaining authentic and accurate information, users contribute to
          a transparent, efficient, and secure experience on AstroBhagya.
        </p>

        {/* ───────────────────────── 11 ───────────────────────── */}
        <h5>11. Your Rights</h5>
        <p>
          AstroBhagya is committed to respecting and protecting your privacy
          rights. Subject to applicable laws, including the Information
          Technology Act, 2000, and other relevant regulations, users may have
          the following rights with respect to their personal information:
        </p>
        <ul>
          <li>
            <strong>Right to Access</strong>
            <br />
            You have the right to access and review the personal information we
            maintain about you. This includes details collected during
            registration, consultations, transactions, and any other
            interactions with the Platform. Accessing your data allows you to
            verify that the information is accurate and being processed in
            accordance with your consent.
          </li>
          <li>
            <strong>Right to Correction</strong>
            <br />
            You may request corrections or updates to your personal information
            to ensure it is accurate and up-to-date. Accurate information is
            essential for receiving correct astrological guidance, effective
            service delivery, and proper communication.
          </li>
          <li>
            <strong>Right to Withdraw Consent</strong>
            <br />
            Where applicable, you may withdraw your consent for the processing
            of your personal data. Withdrawing consent may affect your ability
            to access certain services or features, as some functionalities
            require the collection and processing of your information.
          </li>
          <li>
            <strong>Right to Deletion</strong>
            <br />
            You may request the deletion of your personal information from our
            systems, subject to legal and operational requirements. This includes
            data associated with your account, profile, and consultation
            history. Certain information may need to be retained for legal
            obligations, such as tax or accounting records, but will be securely
            stored and not actively used.
          </li>
        </ul>
        <p>
          <strong>Exercising Your Rights</strong>
          <br />
          To exercise any of these rights, please contact our designated
          Grievance Officer (see Section 13). We are committed to responding to
          all requests within the timeframes prescribed by applicable law. When
          processing such requests, we may require verification of identity to
          ensure that your personal information is protected and handled
          securely.
        </p>

        {/* ───────────────────────── 12 ───────────────────────── */}
        <h5>12. Changes to this Privacy Policy</h5>
        <p>
          AstroBhagya may update this Privacy Policy periodically to reflect
          changes in practices, technology, legal requirements, or other factors
          affecting the collection, processing, and storage of your information.
        </p>

        <p>
          <strong>Notification of Changes</strong>
        </p>
        <ul>
          <li>
            When material changes are made, we will post the updated Privacy
            Policy on our Platform and update the "Last Updated" date at the
            bottom of this document.
          </li>
          <li>
            Users are encouraged to review the Privacy Policy periodically to
            stay informed about how we collect, use, and protect your
            information.
          </li>
          <li>
            Continued use of the Platform after the posting of changes
            constitutes your acceptance of the revised Privacy Policy.
          </li>
        </ul>
        <p>
          By updating our Privacy Policy, AstroBhagya ensures transparency,
          compliance with evolving legal standards, and ongoing protection of
          user information.
        </p>

        {/* ───────────────────────── 13 ───────────────────────── */}
        <h5>13. Grievance Officer</h5>
        <p>
          In accordance with the Information Technology Act, 2000, and the rules
          made thereunder, AstroBhagya has appointed a Grievance Officer
          responsible for addressing privacy concerns, complaints, and requests
          related to your personal information.
        </p>

        <p>
          <strong>Contact Information</strong>
        </p>
        <ul>
          <li>
            <strong>Email:</strong>{" "}
            <Link to="mailto:business@astrobhagya.co.in">
              business@astrobhagya.co.in
            </Link>
          </li>
        </ul>

        <p>
          <strong>Role and Responsibilities</strong>
        </p>
        <ul>
          <li>
            Handling inquiries, complaints, or discrepancies regarding personal
            data collection, processing, or storage.
          </li>
          <li>
            Assisting users in exercising their privacy rights, including
            access, correction, deletion, and withdrawal of consent.
          </li>
          <li>
            Responding to concerns promptly and taking all reasonable steps to
            resolve issues in accordance with applicable laws.
          </li>
        </ul>

        <p>Users are encouraged to contact the Grievance Officer for any questions regarding:</p>
        <ul>
          <li>How personal data is collected, processed, and used.</li>
          <li>Security measures protecting user information.</li>
          <li>
            Requests for access, correction, or deletion of personal
            information.
          </li>
          <li>Complaints about potential misuse of personal data.</li>
        </ul>

        <p>
          AstroBhagya is committed to addressing user concerns{" "}
          <b>quickly, transparently, and in compliance with legal obligations.</b>
        </p>

        <p>
          <em>
            <b>Last Updated:</b> 18th September 2025
          </em>
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
